import { TranslationRepository } from '../data/translation-repository';
import { RollbackResult } from '../types/translation-types';

export class RollbackVersionUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(versionId: number, reason: string): Promise<RollbackResult> {
    return this.repository.rollbackVersion(versionId, reason);
  }
}
